import * as z from "zod/v4";

export const ProductivityDashboardItemSchema = z.object({
  teamMemberName: z.string(),
  teamMemberEmail: z.string(),
  ordersFulfilled: z.number(),
  productsFulfilled: z.number(),
  ouncesFulfilled: z.number(),
  dollarsSpent: z.number(),
  averageDollarsPerOunce: z.number(),
  ordersVerified: z.number(),
  ordersVerifiedRate: z.number(),
});

export type ProductivityDashboardItem = z.infer<
  typeof ProductivityDashboardItemSchema
>;
